import { render } from "./DocumentsLGHome.vue?vue&type=template&id=0de5dc11&scoped=true"
import script from "./DocumentsLGHome.vue?vue&type=script&lang=js"
export * from "./DocumentsLGHome.vue?vue&type=script&lang=js"

import "./DocumentsLGHome.vue?vue&type=style&index=0&id=0de5dc11&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de5dc11"]])

export default __exports__